import { useForm, Controller } from 'react-hook-form'
import { Box, Grid, TextField, Button } from '@mui/material'
import { useInsumo } from '../../../shared/context/insumoContext'
import { useUtiles } from '../../../shared/context/utilesContext'
export default function CreateTypeInsumoComponent() {
    const { createTypeInsumo, loadingCreateTypeInsumo } = useInsumo()
    const { handleSubmit, control, formState: { errors } } = useForm()
    const { restorePreviousComponent } = useUtiles()

    const handleCreateTypeInsumo = async (data) => {
        await createTypeInsumo(data)
    }

    return (
        <Box sx={{
            padding: '10px',
        }}>
            <form onSubmit={handleSubmit(handleCreateTypeInsumo)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, }}>
                    <Controller
                        control={control}
                        name="name"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Nombre" {...field} error={!!errors.name} helperText={errors.name?.message} />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12}}>
                        <Button type="submit" variant="contained" color="primary" disabled={loadingCreateTypeInsumo}>{loadingCreateTypeInsumo ? 'Creando...' : 'Crear'}</Button>
                        <Button 
                            variant="contained" 
                            color="disabled" 
                            sx={{ ml: 1 }}
                            onClick={restorePreviousComponent}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}

